import React from 'react';

import Spinner from 'components/ui/Spinner';
import guardMeLoggedIn from 'utils/guardMeLoggedIn';
import classes from './Guard.module.css';

export interface GuardProps {
  children: React.ReactNode;
  loading?: boolean;
}

const GuardLoggedIn: React.FC<GuardProps> = ({ children, loading }) => {
  const { meLoading } = guardMeLoggedIn();

  if (meLoading || loading) {
    return (
      <div className={classes.container}>
        <Spinner />
        Laddar...
      </div>
    );
  }

  return children;
};

export default GuardLoggedIn;
